import { render, staticRenderFns } from "./market-overview.vue?vue&type=template&id=050d7310&scoped=true&"
import script from "./market-overview.vue?vue&type=script&lang=js&"
export * from "./market-overview.vue?vue&type=script&lang=js&"
import style0 from "./market-overview.vue?vue&type=style&index=0&id=050d7310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050d7310",
  null
  
)

export default component.exports